import { toast } from 'react-toastify';
import axios from '@utils/axios';
import Translate from '../components/translate/conf';
import React, { Component } from 'react';
import ModalLoading from '@app/components/modal-loading/modal-loading';

class FirmwareUpgradePage extends Component {

  // API Endpoints
  constructor(props) {
    super(props);
    this.checkIfUpgrading()
  }

  fwState = 0
  timerId = -1;
  state = {
    fw_filename: null,
    mLoading: false,
    mUpload: false
  }

  checkIfUpgrading = async () => {
    try {
      let response = await axios('/api/firmware/upload');
      let status = response.data.status;
      let err = response.data.err;
      if( err === '' && status == 1 ){
        this.waitProcess(true)
      }
    } catch (err) {
      console.log(err)
    }
  }

  handleSelectFile = (e) => {
    let result = null
    let filename = e.target.files[0].name;
    if (filename.substr(-3) == 'bin') {
      result = filename
    } else {
      toast.error(<Translate transVar="FirmwareUpgrade.InvalidExtensionFile" />)
    }
    this.setState({
      fw_filename: result
    })
  }

  monitorUpgrade = async () => {
    let status = 0;
    let err = '';
    try {
      let response = await axios({ url: '/api/firmware/upload', timeout: 900 });
      status = response.data.status;
      err = response.data.err;
    } catch (e) {
      status = 1;
    }
    if (err === '') {
      if (this.fwState == 1) {
        if (status == 1) {
          this.fwState = 0;
        }
      } else if (this.fwState == 0 && status == 0) {
        toast.success(<Translate transVar="ManagementCard.ApplySuccess" />)
        this.waitProcess(false)
        setTimeout(() => axios('/api/login').catch(), 3000);
      }
    }
  }

  waitProcess = (en) => {
    if (en) {
      if (this.timerId > 0) return;
      this.fwState = 1;
      this.timerId = setInterval(this.monitorUpgrade, 1000)
      this.setState({ mLoading: true });
    } else {
      if (this.timerId === -1) return;
      clearInterval(this.timerId);
      this.timerId = -1;
      this.setState({ mLoading: false });
    }
  }

  // File Submit Handler
  handleSubmitFile = (e) => {
    e.preventDefault()
    if (this.state.fw_filename != null) {
      this.waitProcess(true)
      let checkFinish=-1;
      let webServer = window.location.hostname
      // let webServer = "192.168.0.88"
      const webSocket = new WebSocket('ws://'+webServer+'/websock');
      webSocket.onerror = (event) => {
				console.log(event)
        // toast.error(event)
        this.waitProcess(false)
      }
      webSocket.onopen = (event) => {
        const reader = new FileReader();
        reader.onload = (res) => {
          try {
            let end=0,start = 0;
            let data = res.target.result.substr(res.target.result.indexOf(',')+1)
            while( end < data.length ){
              end += 10240;
              end = end < data.length ? end : data.length;
              webSocket.send(data.slice(start,end))
              start = end;
            }
          } catch(e) {
            console.log(e)
            toast.error(e)
            this.waitProcess(false)
          }
          this.waitProcess(true)
          checkFinish = setInterval( () => {
            try {
              if( webSocket.bufferedAmount === 0 ){
                webSocket.close();
                clearInterval(checkFinish)
              }  
            } catch(e){
              console.log(e)
              toast.error(e)
              this.waitProcess(false)     
              clearInterval(checkFinish)           
            }
          },1000);
        }
        reader.readAsDataURL(e.target[0].files[0]);
			};
			// webSocket.onmessage = (event) => {
			// 	console.log(event)
			// };
    }
  }

  // render from here
  render() {
    return (
      <>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1><Translate transVar='menusidebar.label.ManagementCard.FirmwareUpgrade' /></h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Translate transVar='menusidebar.label.ManagementCard.Parent' />
                  </li>
                  <li className="breadcrumb-item active">
                    <Translate transVar='menusidebar.label.ManagementCard.FirmwareUpgrade' />
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6">
                <div className="card card-primary">
                  <div className="card-header">
                    <h3 className="card-title"><Translate transVar='ManagementCard.FirmwareUpgrade.FirmwareUpgrade' /></h3>
                  </div>
                  <ModalLoading show={this.state.mLoading} />
                  <form onSubmit={this.handleSubmitFile}>
                    <div className="card-body">
                      <div className="form-group">
                        <label><Translate transVar='ManagementCard.FirmwareUpgrade.SelectFirmwareFile' /></label>
                      </div>
                      <div className="form-group">
                        <input type="file" name="files" onChange={this.handleSelectFile} accept=".bin" />
                      </div>
                      <div className="form-group">
                        <i className="info">- <Translate transVar='ManagementCard.AfterRebootLogout' /></i>
                      </div>
                    </div>
                    <div className="card-footer">
                      <button type="submit" className="btn btn-primary"><Translate transVar='Button.Apply' /></button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default FirmwareUpgradePage;